// extracted by mini-css-extract-plugin
module.exports = {"content_tile":"PaginationComp_content_tile__kOnPy","mobile_height":"PaginationComp_mobile_height__dE2d0"};